import React from "react";
import { Check } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import Reveal from "@/components/anim/Reveal";

const AboutSection = () => {
  const { t } = useLang();

  return (
    <section className="bg-brand-surface section-y" data-testid="about-section">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5">
          <div className="relative group">
            <div className="absolute -top-4 -left-4 h-full w-full border border-brand-deep/30 pointer-events-none transition-transform duration-700 group-hover:-translate-y-1 group-hover:-translate-x-1" />
            <div className="relative overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80"
                alt="RAYTECH Advisory workspace"
                className="w-full aspect-[4/5] object-cover transition-all duration-700 group-hover:scale-[1.03]"
                data-testid="about-founder-image"
              />
            </div>
            <div className="relative -mt-px bg-brand-ink text-white p-5">
              <p className="font-heading font-bold tracking-tight">RAYTECH Advisory</p>
              <p className="text-xs text-white/60 mt-1">{t.about.founder_role}</p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal delay={120}>
            <p className="overline">{t.about.eyebrow}</p>
            <h2 className="mt-4 font-heading font-bold text-brand-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.about.title}
            </h2>
            <p className="mt-7 text-lg text-brand-muted leading-relaxed">{t.about.p1}</p>
            <p className="mt-5 text-lg text-brand-muted leading-relaxed">{t.about.p2}</p>
          </Reveal>

          <ul className="mt-10 space-y-4">
            {t.about.bullets.map((b, i) => (
              <Reveal as="li" key={i} delay={200 + i * 80} className="flex items-start gap-3" data-testid={`about-bullet-${i}`}>
                <span className="mt-1 inline-flex h-5 w-5 items-center justify-center bg-brand-deep text-white transition-transform duration-300 hover:scale-110 hover:rotate-6">
                  <Check size={12} strokeWidth={3} />
                </span>
                <span className="text-brand-ink/90 leading-relaxed">{b}</span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
